export const starTrackGitHubMaintainer = "seladb";
export const starTrackGitHubRepo = `https://github.com/${starTrackGitHubMaintainer}/startrack-js`;
export const twitter = "https://twitter.com/seladb";
export const email = "pcapplusplus@gmail.com";
